export const responseParser = (response) => {
    return JSON.parse(response);
};
//# sourceMappingURL=ResponseParser.js.map